import React from 'react';
import styled from 'styled-components';
import planeTop from '../../assets/concorde-sketch.png';
import planeSide from '../../assets/concorde-side.png';
import grid from '../../assets/grid.png';
import { device } from '../../utils/device-sizes';

const ConstructionDiv = styled.div`
  position: relative;
  overflow: hidden;
  height: 100vh;
  width: 100%;
  background-color: #162f43;
  background-image url('${grid}');
  background-size: 20px;
  padding-top: 78px;
  font-family: Montserrat, sans-serif;

  @media ${device.mobileS} {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  @media ${device.laptop} {
    display: block;
  }
`;

const Announcement = styled.div`
  @media ${device.mobileS} {
    text-align: center;
    margin-bottom: 78px;
  }

  @media ${device.tablet} {
    padding: 90px 85px;
    margin-bottom: 0px;
  }

  @media ${device.tabletL} {
    padding: 150px 85px;
  }

  @media ${device.laptop} {
    text-align: left;
    padding: 100px 85px;
  }

  @media ${device.desktop} {
    padding: 120px 85px;
  }

  @media ${device.desktopL} {
    padding: 300px 85px;
  }
`;

const Header = styled.h1`
  color: white;

  @media ${device.mobileS} {
    font-size: 2em;
    line-height: 1.1;
    margin-bottom: 10px;
  }

  @media ${device.tablet} {
    font-size: 3.5em;
    margin-bottom: 20px;
  }
  
  @media ${device.tabletL} {
    font-size: 5em;
  }

  @media ${device.laptop} {
    font-size: 4em;
  }

  @media ${device.desktop} {
    font-size: 6em;
  }

  @media ${device.desktopL} {
    font-size: 13em;
  }
`;

const Subheader = styled.h2`
  color: white;

  @media ${device.mobileS} {
    font-size: 1.1em;
    letter-spacing: 0.7%
  }

  @media ${device.tablet} {
    font-size: 1.7em;
  }

  @media ${device.laptop} {
    font-size: 1.5em;
    margin-left: 10px;
  }

  @media ${device.desktopL} {
    font-size: 3em;
    margin-left: 20px;
  }
`;

const PlaneSide = styled.img`
  position: absolute;

  @media ${device.mobileS} {
    top: 10%;
    left: -110%;
    height: 172px;
  }

  @media ${device.mobileL} {
    left: -60%;
    height: 172px;
  }

  @media ${device.tablet} {
    left: -9.5%;
    height: 172px;
  }

  @media ${device.tabletL} {
    top: 10%;
    left: -30.5%;
    height: 272px;
  }

  @media ${device.laptop} {
    top: 70%;
    left: -9.5%;
    height: 200px;
  }

  @media ${device.desktop} {
    height: 272px;
  }

  @media ${device.desktopL} {
    left: -9.5%;
    height: 572px;
  }
`;

const PlaneTop = styled.img`
  position: absolute;
  z-index: 1;

  @media ${device.mobileS} {
    right: -110%;
    bottom: -10%;
    height: 472px;
    width: 750px;
  }

  @media ${device.mobileL} {
    right: -60%;
    bottom: 10%;
  }

  @media ${device.tablet} {
    right: -9.5%;
    bottom: -10%;
  }

  @media ${device.tabletL} {
    right: -20.5%;
    height: 672px;
    width: 1050px;
  }

  @media ${device.laptop} {
    right: -9.5%;
    bottom: 10%;
    height: 472px;
    width: 850px;
  }

  @media ${device.desktop} {
    bottom: 40%;
    height: 672px;
    width: 1200px;
  }

  @media ${device.desktopL} {
    right: -5.5%;
    height: 1272px;
    width: 2400px;
  }
`;

// const SectionCut = styled.div`
//   position: absolute;
//   bottom: 0%;
//   height: 171px;
//   width: 100%;
//   background-color: #B5E6F9;
//   z-index: 2;
// `;

export default function Construction() {
  return(
    <ConstructionDiv>
      <Announcement>
        <Header>🚧🔨👷‍♀️ <br />Yup, it's Concorde.</Header>
        <Subheader>But we're still not done fixing her yet.<br/>
        How 'bout you come back again next time?</Subheader>
      </Announcement>
      <PlaneSide src={planeSide} />
      <PlaneTop src={planeTop} />
    </ConstructionDiv>
  );
}